module.exports = __webpack_public_path__ + "static/media/02.45a77c69.jpg";